import { gql } from "@apollo/client";
import { TextField } from "@mui/material";
import apolloClient from "helpers/apolloClient";
import { ONSEN_AUTH_TOKEN_KEY } from "helpers/constants";
import useActionFragment from "helpers/useActionFragment";
import useData from "helpers/useData";
import { progressBar } from "helpers/useProgressBar";
import useShowMessage from "helpers/useShowMessage";
import FormDialog from "molecules/FormDialog";
import Message from "molecules/Message";
import React, { useLayoutEffect, useState } from "react";

export default function UpdateStubbedUserEmailModal({ open, onClose }) {
  const [email, emailSet] = useState("");
  const [personData] = useData(gql`
    query GameOverviewUpdateStubbedUserEmailModal {
      currentUser {
        people {
          id
        }
      }
    }
  `);
  const stubbedUserEmailUpdate = useActionFragment("stubbedUserEmailUpdate", "authToken");

  useLayoutEffect(() => {
    emailSet("");
  }, [open]);

  const showMessage = useShowMessage();

  return (
    <FormDialog
      title="Connect your Profile"
      open={open}
      onClose={onClose}
      onSubmit={async () => {
        try {
          const result = await stubbedUserEmailUpdate({
            input: {
              personId: personData.currentUser.people[0].id,
              newEmail: email,
            },
          });
          showMessage(
            "Your email has been connected to your Glory League profile. We've sent you an email with next steps to access your account.",
          );
          if (result.stubbedUserEmailUpdate.authToken?.length > 0) {
            window.localStorage.setItem(ONSEN_AUTH_TOKEN_KEY, result.stubbedUserEmailUpdate.authToken);
            await progressBar(() => apolloClient.refetchQueries({ include: "active" }));
          }
        } catch {
          showMessage("An error occurred when connecting your email. Please refresh the browser and try again.");
        }
      }}
      submitButtonLabel="Connect My Profile"
    >
      <Message>Connecting your email will give you access to your Glory League profile.</Message>
      <TextField
        label="Email"
        type="email"
        autoComplete="email"
        value={email}
        onChange={(event) => emailSet(event.target.value)}
        required
      />
    </FormDialog>
  );
}
